// import { injected } from "./utils/Web3Connectors";
import React from "react";
import { useSsrEffect } from "@issr/core";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { coinBase } from "@bkry/bowline-connectors";
import { chains } from "@bkry/bowline-connectors";
import { setKeepWalletConnection } from "@bkry/bowline-redux/wallets";
import { useDispatch } from "react-redux";
import { getEnv } from "@bkry/bowline-utils";

const CoinbaseConnectButton = (props, context) => {
  const REACT_APP_MAINNET = getEnv("REACT_APP_MAINNET");
  const dispatch = useDispatch();
  const { suggestedChainId } = props;
  const chainId = suggestedChainId
    ? suggestedChainId
    : REACT_APP_MAINNET
    ? 1
    : 11155111;
  //props from web 3 must be instantiated wherever function is used

  useSsrEffect(() => {
    void coinBase
      .connectEagerly()
      .then(() => {
        console.debug("Connected eagerly to coinBase");
        dispatch(
          setKeepWalletConnection({
            keepWalletConnection: true,
            lastProvider: "coinbase",
          })
        );
      })
      .catch(() => {
        console.debug("Failed to connect eagerly to coinBase");
      });
  }, []);

  const handleConnect = () => {
    if (
      coinBase &&
      window.ethereum &&
      (window.ethereum.isCoinbaseWallet ||
        (window.ethereum.providerMap &&
          [...window.ethereum.providerMap].find(
            (entry) => entry[0] === "CoinbaseWallet"
          )))
    ) {
      coinBase
        .activate(chains.getAddChainParameters(chainId))
        .then(() => {
          dispatch(
            setKeepWalletConnection({
              keepWalletConnection: true,
              lastProvider: "coinbase",
            })
          );
        })
        .catch((err) => console.error(err));
    }
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) &&
      !(window.ethereum && window.ethereum.isCoinbaseWallet)
    ) {
      window.location =
        "https://go.cb-w.com/dapp?cb_url=" +
        window.location.host +
        window.location.pathname;
      return;
    }
  };

  // useSsrEffect(() => {
  //   handleConnect();
  // }, []);

  return (
    <Button onClick={handleConnect} className="mb-3" color="primary" size="lg">
      {context.t("Connect with Coinbase Wallet")}
    </Button>
  );
};

/**  define proptype for the 'translation' function  */
CoinbaseConnectButton.contextTypes = {
  t: PropTypes.func,
};

export default CoinbaseConnectButton;
